<img [class]="cx('image')" [src]="image()" [alt]="description()" />

<div [class]="cx('text')">
  <h2 [class]="cx('caption')">
    {{ caption() }}
  </h2>

  <p [class]="cx('description')">
    {{ description() }}
  </p>
</div>

<ng-content />
